import { VictoryThemeDefinition } from 'victory-core/src/victory-theme/types';
import { VictoryTheme } from 'victory';

export const getGraphTheme = ({ estimate }: { estimate?: boolean } = { estimate: false }): VictoryThemeDefinition => ({
    ...VictoryTheme.clean,
    chart: {
        padding: {
            top: 20,
            right: 40,
            bottom: 40,
            left: 80,
        },
    },
    axis: {
        style: {
            grid: { stroke: 'none' },
            axis: {
                strokeWidth: 0,
            },
            tickLabels: {
                fontFamily: 'Open sans',
                fill: '#4D7477',
                fontSize: 16,
                fontWeight: 600,
                padding: 5,
            },
        },
        offsetY: 30,
    },
    dependentAxis: {
        style: {
            grid: estimate ? { opacity: 0.2, stroke: '#00383D', strokeWidth: 1 } : { stroke: 'none' },
            axis: {
                strokeWidth: 0,
            },
            tickLabels: {
                fontFamily: 'Open sans',
                fill: '#4D7477',
                fontSize: 16,
                fontWeight: 600,
                padding: 5,
            },
        },
        offsetX: 70,
    },
    line: {
        style: {
            data: {
                stroke: '#00383D',
                strokeWidth: 2,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeMiterlimit: 1,
            },
        },
    },
});

export const zeroAxisStyles = {
    data: {
        opacity: 0.5,
        strokeWidth: 1.5,
    },
};

export const colorFundMap = {
    XL8000278662: '#00383D',
    XL8000790856: '#34AFD9',
    XL8000339969: '#56A356',
    XL8000895788: '#968678',
};
